// Utils
import { conditionallyGroupObjectProperties, depthOfPath } from 'ezyvet-fe-helpers';
var objectAdditionCheck = function (value, key) { return (depthOfPath(key) === 1 && value[0] === undefined); };
var objectRemovalCheck = function (value, key) { return (depthOfPath(key) === 1 && value[1] === undefined); };
var propertyDeletionCheck = function (value) { return value[1] === undefined; };
var arrayChangeCheck = function (value) { return Array.isArray(value[1]); };
/**
 * Sorts the given list of changes into..
 *
 * {
 *   newObjects, // A list of new object which have been added
 *   objectRemovals, // A list changes for object that have been removed
 *   propertyDeletions, // A list changes for properties that have been removed
 *   arrayChanges, // A list changes for arrays that have changed
 *   valueChanges, // A list changes for properties whose values have been changed
 * }
 *
 * @param {ChangeList} changes
 *
 * @return {SortChangesResult}
 */
export var sortChanges = function (changes) {
    var _a = conditionallyGroupObjectProperties(changes, objectAdditionCheck, objectRemovalCheck, propertyDeletionCheck, arrayChangeCheck), objectAdditions = _a[0], objectRemovals = _a[1], propertyDeletions = _a[2], arrayChanges = _a[3], valueChanges = _a[4];
    var newObjects = {};
    Object.keys(objectAdditions).forEach(function (key) {
        var _a = objectAdditions[key], newValue = _a[1];
        newObjects[key] = newValue;
    });
    return {
        newObjects: newObjects,
        objectRemovals: objectRemovals,
        propertyDeletions: propertyDeletions,
        arrayChanges: arrayChanges,
        valueChanges: valueChanges,
    };
};
//# sourceMappingURL=sortChanges.js.map